import { MB } from './video.js';
// ─────────────────────────────────────────────────────────────────────────────
// Media kinds: SINGLE SOURCE OF TRUTH for `media.kind` (supabase/migrations: enum
// `media_kind`). Client and server both read this list instead of repeating the
// literal union, so a new kind (e.g. 'voiceover') is added in one place.
// ─────────────────────────────────────────────────────────────────────────────
export const MEDIA_KINDS = ['video', 'document', 'headshot', 'voiceover', 'other'];
export const isMediaKind = (v) => typeof v === 'string' && MEDIA_KINDS.includes(v);
/** A clear, human label for a kind pill in the gallery and uploader buttons. */
export const MEDIA_KIND_LABELS = {
    video: 'Video',
    document: 'Document',
    headshot: 'Headshot',
    voiceover: 'Voiceover',
    other: 'Other',
};
/** Audio formats a voiceover reel or VO audition commonly comes in. */
const VOICEOVER_FORMATS = {
    MP3: ['audio/mpeg', 'audio/mp3'],
    WAV: ['audio/wav', 'audio/x-wav', 'audio/wave', 'audio/vnd.wave'],
    M4A: ['audio/mp4', 'audio/x-m4a'],
    AAC: ['audio/aac'],
    AIFF: ['audio/aiff', 'audio/x-aiff'],
    OGG: ['audio/ogg'],
    Opus: ['audio/opus'],
};
const VOICEOVER_MIME = new Set(Object.values(VOICEOVER_FORMATS).flat());
/** Browser picker and format copy follow the server's allowlist. */
export const VOICEOVER_UPLOAD_ACCEPT = [...VOICEOVER_MIME].join(',');
/**
 * Per-kind MIME allowlist. Audio must use voiceover so another kind cannot bypass its cap.
 * Other formats keep the existing behavior for kinds with no entry here.
 */
const MIME_BY_KIND = {
    voiceover: VOICEOVER_MIME,
};
export const mimeAllowedForKind = (kind, mime) => {
    const normalized = typeof mime === 'string' ? mime.toLowerCase() : '';
    if (normalized.startsWith('audio/') && kind !== 'voiceover')
        return false;
    const allowed = MIME_BY_KIND[kind];
    if (!allowed)
        return true;
    return allowed.has(normalized);
};
/**
 * Hard per-file ceiling for a voiceover upload. VO reels and VO auditions are short audio
 * clips, nowhere near the 500 MB video ceiling (`MAX_UPLOAD_BYTES`); even an uncompressed
 * WAV of a long audition session rarely passes this. Enforced server-side (storage.ts), since
 * the Supabase project's own file-size cap (500 MB, kept in sync with MAX_UPLOAD_BYTES) is far
 * too generous for audio on its own.
 */
export const MAX_VOICEOVER_UPLOAD_BYTES = 200 * MB;
export const VOICEOVER_UPLOAD_HINT = `${Object.keys(VOICEOVER_FORMATS).join(', ')}. Up to ${MAX_VOICEOVER_UPLOAD_BYTES / MB} MB per file.`;
/** The per-file ceiling for a given kind. Only voiceover is tighter than the global upload cap. */
export const maxBytesForKind = (kind, defaultMax) => kind === 'voiceover' ? MAX_VOICEOVER_UPLOAD_BYTES : defaultMax;
//# sourceMappingURL=media.js.map